export default __webpack_public_path__ + "static/media/corogated-panel.bef7c91e.jpg";